import React, { useContext } from "react";
import PropTypes from "prop-types";
import { ACCOUNT_TYPE_TEMPORARY } from "@config/config";
import { AuthContext } from "@context/AuthContext";
import { BookSessionContext } from "@context/BookSessionContext";
import { CheckoutComplimentaryContext } from "@context/CheckoutComplimentaryContext";
import Button from "@components/Ui/Button";
import Spinner from "@components/Ui/Spinner";
import "./style.scss";

const calcTotalPrice = (carry, item) => carry + item.price_cents * item.quantity;
const calcTotalDisplayPrice = (carry, item) => carry + (item.display_price_cents ?? 0) * item.quantity;
const calcTotalQuantity = (carry, item) => carry + item.quantity;

const SummaryTotal = ({ items, handleCheckout, isContactDetailsValid }) => {
    const { isLoggedIn, user, drawerState } = useContext(AuthContext);
    const {
        isSubmitting: isBookingSubmitting,
        termsAccepted,
        proceedToCheckout,
        isStripeCheckoutLoading
    } = useContext(BookSessionContext);
    const { isSubmitting: isComplimentarySubmitting } = useContext(CheckoutComplimentaryContext);

    // Keep spinning through the second Stripe call until its drawer is ready.
    const isSubmitting = isBookingSubmitting || isComplimentarySubmitting || isStripeCheckoutLoading;

    const totalQuantity = items.reduce(calcTotalQuantity, 0);
    const totalPrice = items.reduce(calcTotalPrice, 0);
    const totalDisplayPrice = items.reduce(calcTotalDisplayPrice, 0);

    const isTempSubscriber = !isLoggedIn || user.account_type_id === ACCOUNT_TYPE_TEMPORARY;
    const addTicketButtonText = totalPrice > 0 ? "Checkout" : isTempSubscriber ? "Login to Checkout" : "Confirm Order";

    return (
        <div className="voucher-search__summary-total">
            <div
                className={`voucher-search__summary-price ${
                    totalQuantity === 0 ? "voucher-search__summary-price--quantity-none" : ""
                }`}
            >
                {totalPrice > 0
                    ? `Total Price: $${(totalPrice / 100).toFixed(2)}`
                    : `Customer Price: $${(totalDisplayPrice / 100).toFixed(2)}`
                }
            </div>

            <Button
                onClick={handleCheckout}
                additionalClasses="button button__primary"
                disabled={
                    !termsAccepted || isSubmitting || !isContactDetailsValid || proceedToCheckout
                    || drawerState.stripeCheckoutDrawer
                    ? "disabled"
                    : ""
                }>

                {isSubmitting ? <Spinner text="loading..."/> : addTicketButtonText}
            </Button>
        </div>
    );
};

SummaryTotal.propTypes = {
    items: PropTypes.arrayOf(
        PropTypes.shape({
            id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
            quantity: PropTypes.number.isRequired,
            price_cents: PropTypes.number.isRequired,
            rrp_price_cents: PropTypes.number,
            display_price_cents: PropTypes.number
        })
    ).isRequired,
    handleCheckout: PropTypes.func.isRequired,
};

export default SummaryTotal;
